<template lang="pug">
.event-list-item
  article.card.is-paddingless(:class="{ 'is-hoverable': hoverable }")
    .card-image
      router-link(:to="{ name: 'event', params: { id: event.key } }")
        figure.image.is-16by9
          cl-img(
            v-if="event._embedded.artwork"
            :cl-id="event._embedded.artwork.cl_id"
            :transform="{ width: 640, height: 360 }"
          )
    .card-content
      .card-grow
        .card-title
          router-link.main(:to="{ name: 'event', params: { id: event.key } }") {{ event.title }}
          .sub
            event-date(
              format="MMMM D"
              :limit="limit"
              :month="month"
              :value="event"
            )
        .card-location(v-if="event._embedded.location.id")
          b-icon(icon="map-marker-outline")
          span(v-html="event._embedded.location.label")
        .card-desc(@click="redirect")
          p {{ event.short_desc }}
      .card-meta
        .level.is-mobile
          .level-left
            .level-item(v-if="fromCost > 0") From {{ fromCost | cents }}
            .level-item(
              v-for="ministry in event._embedded.ministries"
              :key="ministry.id"
            ) {{ ministry.name }}
</template>

<script>
import _ from 'lodash';
import EventDate from '@/components/events/EventDate.vue';

export default {
  name: 'event-list-item',
  components: {
    EventDate,
  },
  computed: {
    event() {
      return this.value;
    },
    fromCost() {
      if (!this.event.payment_required || this.event._embedded.packages.length === 0) return 0;
      const cheapest = _.minBy(this.event._embedded.packages, p => p.cost);
      if (cheapest) return cheapest.cost;
      return 0;
    },
  },
  methods: {
    redirect() {
      this.$router.push({
        name: 'event',
        params: {
          id: this.event.key,
        },
      });
    },
  },
  props: {
    hoverable: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String,
      default: 'single',
    },
    month: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.event-list-item {
  @include listItem;
  height: 100%;
  article.card {
    height: 100%;
    .card-content {
      .card-grow {
        height: 128px;
      }
      .card-location {
        margin-top: 0.5rem;
        margin-left: -4px;
        display: flex;
        align-items: center;
        .icon {
          margin-right: 0.1rem;
        }
      }
    }
  }
}
</style>
